import CustomerReportActions from './actions';

const INITIAL_STATE = {
  data: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  isNewRecord:false,
  showModal:false,
  onSubmit:false,
  single:null,
  helperCustomerReport:[],
  errorInternal:false,
  printCustomerReport:null
};

function CustomerReportReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CustomerReportActions.RESET_LIST:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false,single:null, form:INITIAL_STATE.form,data:{}};
    case CustomerReportActions.NEW_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false,single:null, errorMessage:[],form:INITIAL_STATE.form,isNewRecord:true,showModal:true};
    case CustomerReportActions.UPDATE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:null,isNewRecord:false};
    case CustomerReportActions.VIEW_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:action.payload,errorMessage:[],isNewRecord:false,showModal:true};
    case CustomerReportActions.RESET_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case CustomerReportActions.DELETE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case CustomerReportActions.ON_SUBMIT:
      return { ...state, errorInternal:false,onSubmit:true};
    case CustomerReportActions.SHOW_DATA:
      return { ...state, errorInternal:false,onSubmit:false, isError: false, data: action.payload, errorMessage: [],isProcessing:false };
    case CustomerReportActions.ERROR_DATA:
      return { ...state, errorInternal:false, isError: true,onSubmit:false,  errorMessage: action.payload,isProcessing:false };
    case CustomerReportActions.SUCCESS_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isError: false, showModal:false,form:INITIAL_STATE.form , onSubmit:false};
    case CustomerReportActions.PROCESS_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: true, isError: false,isSuccess:false};
    case CustomerReportActions.GET_HELPER_CUSTOMERREPORT:
      return { ...state,errorInternal:false, isError: false,isSuccess:false,onSubmit:false,helperCustomerReport:action.payload};
    case CustomerReportActions.ERROR_SERVER:
      return { ...state,  isError: false, errorInternal:true, onSubmit:false,  errorMessage: action.payload, isProcessing:false };
    case CustomerReportActions.BEFORE_PRINT_CUSTOMERREPORT:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,printCustomerReport:null,isProcessing:true};
    case CustomerReportActions.PRINT_CUSTOMERREPORT:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,printCustomerReport:action.payload,isProcessing:false};
       
    default:
      return state;
    }
}

export default CustomerReportReducer;
